import { render, staticRenderFns } from "./news_detail_view.vue?vue&type=template&id=384742d8&scoped=true&"
import script from "./news_detail_view.vue?vue&type=script&lang=js&"
export * from "./news_detail_view.vue?vue&type=script&lang=js&"
import style0 from "./news_detail_view.vue?vue&type=style&index=0&id=384742d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384742d8",
  null
  
)

export default component.exports